import { render, staticRenderFns } from "./AutoPostBoostingEdit.vue?vue&type=template&id=553305ab&scoped=true&"
import script from "./AutoPostBoostingEdit.vue?vue&type=script&lang=ts&"
export * from "./AutoPostBoostingEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AutoPostBoostingEdit.vue?vue&type=style&index=0&id=553305ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553305ab",
  null
  
)

export default component.exports